import { styled, Box } from '@mui/material';

export const DashboardVariantV2CarrierZoneSaturationContainer = styled(Box)(
  ({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    marginBottom: theme.spacing(2),
  }),
);
